import React, { createContext, useMemo, useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getTheme } from "../theme/theme";

interface ColorModeContextType {
    toggleColorMode: () => void;
    mode: "light" | "dark";
}

export const ColorModeContext = createContext<ColorModeContextType>({
    toggleColorMode: () => { },
    mode: "light",
});

export const ColorModeProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [mode, setMode] = useState<"light" | "dark">("light");

    useEffect(() => {
        const stored = localStorage.getItem("themeMode");
        if (stored) setMode(stored as "light" | "dark");
    }, []);

    const toggleColorMode = () => {
        const newMode = mode === "light" ? "dark" : "light";
        localStorage.setItem("themeMode", newMode);
        setMode(newMode);
    };

    const theme = useMemo(() => getTheme(mode), [mode]);

    return (
        <ColorModeContext.Provider value={{ toggleColorMode, mode }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};